import React, { useRef } from 'react';

import { useRouter } from 'next/router';

import Icon from '@components/Icon';
import { THEME } from '@constants/index';
import { useUserStore } from '@store/index';
import { I18n } from '@utils/index';
import { openSetAssPwd } from '@widget/user/FundsPassword';

import styles from './index.module.less';

export const SetAssetsPasswardEntry = () => {
  const router = useRouter();
  const userStore = useUserStore();
  // 是否设置了资金密码
  const { isExistAssetPassword = false } = userStore?.userInfo || {};
  const modalContainerRef = useRef<HTMLDivElement>();

  const onUpdateAssetPwd = async () => {
    await openSetAssPwd({ el: modalContainerRef.current, router, theme: THEME.DARK });
  }
  return !isExistAssetPassword ? (
    (<div className={styles.setAssetsPassward} onClick={onUpdateAssetPwd} ref={modalContainerRef}>
      {I18n.t('fhS4bv96')}{I18n.locale === 'en' ? '\u00A0' : ''}<span className={styles.setBtn}>{I18n.t('Nl62MHkr')}</span>
      <Icon name='toTheRight' className={styles.nextIcon} />
    </div>)
  ) : null;
};
